(function () {
  var root = document.querySelector('[data-recipe-article]');
  if (!root) return;

  var recipeTitle = root.getAttribute('data-recipe-title') || document.title;
  var articleId = root.getAttribute('data-article-id') || '';
  var formulaId = root.getAttribute('data-v2-formula-id') || '';
  var isExtractFormula = formulaId === 'vanilla_extract_one_fold';
  var FAV_KEY = 'vg_blog_favs'; // shared with the blog listing and article hearts

  // GA4 helper — no-ops safely if gtag isn't loaded (ad blockers, etc.).
  function track(eventName, params) {
    if (typeof window.gtag !== 'function') return;
    params = params || {};
    params.recipe_title = recipeTitle;
    window.gtag('event', eventName, params);
  }

  // ---------- Fraction formatting ----------
  // Metaobject decimals come back as 0.75 / 0.25 / 1.5. Cooks read fractions,
  // so every amount is rendered as a vulgar fraction on load and on rescale.
  var FRACTIONS = [
    [0.125, '\u215B'], [0.25, '\u00BC'], [0.333, '\u2153'], [0.375, '\u215C'],
    [0.5, '\u00BD'], [0.625, '\u215D'], [0.667, '\u2154'], [0.75, '\u00BE'], [0.875, '\u215E']
  ];

  function formatAmount(value) {
    if (!isFinite(value)) return '';
    var rounded = Math.round(value * 1000) / 1000;
    var whole = Math.floor(rounded);
    var frac = rounded - whole;

    if (frac < 0.02) return String(whole);

    var best = null;
    var bestDiff = 0.06;
    for (var i = 0; i < FRACTIONS.length; i++) {
      var diff = Math.abs(frac - FRACTIONS[i][0]);
      if (diff < bestDiff) { best = FRACTIONS[i][1]; bestDiff = diff; }
    }
    if (best) return whole > 0 ? whole + '\u2009' + best : best;
    return String(parseFloat(rounded.toFixed(2)));
  }

  function formatMetric(value) {
    if (!isFinite(value)) return '';
    return value >= 10 ? String(Math.round(value)) : String(Math.round(value * 10) / 10);
  }

  function formatWeightOunces(value) {
    if (!isFinite(value)) return '';
    return parseFloat(value.toFixed(2)).toString();
  }

  function formatExtractGrams(value) {
    if (!isFinite(value)) return '';
    return parseFloat(value.toFixed(1)).toString();
  }

  function applyScale(factor) {
    root.querySelectorAll('[data-amount]').forEach(function (el, index) {
      var base = parseFloat(el.getAttribute('data-base-amount'));
      if (!isNaN(base)) {
        el.textContent = isExtractFormula && index === 0
          ? formatWeightOunces(base * factor)
          : formatAmount(base * factor);
      }
    });
    root.querySelectorAll('[data-amount-metric]').forEach(function (el, index) {
      var base = parseFloat(el.getAttribute('data-base-amount-metric'));
      if (!isNaN(base)) {
        el.textContent = isExtractFormula && index === 0
          ? formatExtractGrams(base * factor)
          : formatMetric(base * factor);
      }
    });
  }

  // Render fractions immediately, before any scaling happens.
  applyScale(1);

  // ---------- V2.1.6 yield / serving scaler ----------
  // V1 recipes retain legacy whole-serving behavior. V2 recipes use each
  // formula's validated yield range. Homemade extract stays yield-based:
  // the control is cups, while bean ounces and grams remain visible in the
  // ingredient line and scale proportionally with the selected yield.
  var scaler = root.querySelector('[data-recipe-scaler]');
  if (scaler) {
    var noteEl = root.querySelector('[data-scale-note]');
    var hasV21Contract = root.getAttribute('data-v2-scaler-contract') === 'true';
    var v21Enabled = root.getAttribute('data-v2-scaler-enabled') !== 'false';

    if (hasV21Contract && !v21Enabled) {
      scaler.style.display = 'none';
      scaler.setAttribute('aria-hidden', 'true');
      if (noteEl) noteEl.style.display = 'none';
    } else {
      var baseYield = parseFloat(scaler.getAttribute('data-base-servings')) || 1;
      var input = scaler.querySelector('[data-servings-input]');
      var downBtn = scaler.querySelector('[data-servings-down]');
      var upBtn = scaler.querySelector('[data-servings-up]');
      var resetBtn = scaler.querySelector('[data-servings-reset]');
      var quickBtns = scaler.querySelectorAll('[data-scale]');
      var pluralEl = scaler.querySelector('[data-servings-plural]');
      var scalerLabel = scaler.querySelector('.recipe-article__scaler-label');
      var scaleFired = false;

      var yieldUnit = (root.getAttribute('data-v2-yield-unit') || '').trim();
      var normalizedYieldUnit = yieldUnit.toLowerCase();
      var isServingYield = !normalizedYieldUnit || normalizedYieldUnit === 'serving' || normalizedYieldUnit === 'servings';
      var isCupYield = normalizedYieldUnit === 'cup' || normalizedYieldUnit === 'cups';
      var isQuartYield = normalizedYieldUnit === 'quart' || normalizedYieldUnit === 'quarts';
      var isFluidOunceYield = normalizedYieldUnit === 'fl oz' || normalizedYieldUnit === 'fluid ounce' || normalizedYieldUnit === 'fluid ounces';
      var isContinuousYield = hasV21Contract && (isCupYield || isQuartYield || isFluidOunceYield);
      var yieldStep = isQuartYield ? 0.25 : (isCupYield ? 0.5 : (isFluidOunceYield ? 1 : 1));

      function nearlyEqual(a, b) {
        return Math.abs(a - b) < 0.0001;
      }

      function roundYield(value) {
        return Math.round(value * 1000) / 1000;
      }

      function cleanNumber(value) {
        value = roundYield(value);
        return Number.isInteger(value) ? String(value) : String(parseFloat(value.toFixed(3)));
      }

      function displayYieldNumber(value) {
        return isContinuousYield ? formatAmount(value) : cleanNumber(value);
      }

      function displayYieldUnit(value) {
        var unit = yieldUnit || 'servings';
        if (nearlyEqual(value, 1) && /s$/i.test(unit)) return unit.slice(0, -1);
        if (!nearlyEqual(value, 1) && !/s$/i.test(unit)) return unit + 's';
        return unit;
      }

      function snapYield(value) {
        if (!isContinuousYield) return Math.round(value);
        return roundYield(Math.round(value / yieldStep) * yieldStep);
      }

      var yieldStatValue = null;
      root.querySelectorAll('.recipe-article__stat').forEach(function (stat) {
        var label = stat.querySelector('.recipe-article__stat-label');
        if (!label) return;
        var labelText = (label.textContent || '').trim().toLowerCase();
        if (labelText === 'servings' || labelText === 'yield') {
          yieldStatValue = stat.querySelector('.recipe-article__stat-value');
        }
      });

      var scalerUnitEl = null;
      if (pluralEl && pluralEl.parentElement) {
        var candidate = pluralEl.parentElement;
        if (!candidate.querySelector('input, button')) scalerUnitEl = candidate;
      }

      if (hasV21Contract && !isServingYield && scalerLabel) {
        scalerLabel.textContent = 'Adjust yield';
      }

      var baseControl = baseYield;
      var minControl = 1;
      var maxControl = Math.max(Math.round(baseYield * 8), baseYield + 1);
      var controlStep = yieldStep;

      if (hasV21Contract) {
        var minFactor = parseFloat(root.getAttribute('data-v2-scale-min'));
        var maxFactor = parseFloat(root.getAttribute('data-v2-scale-max'));

        if (!isNaN(minFactor) && minFactor > 0) {
          minControl = baseControl * minFactor;
        }
        if (!isNaN(maxFactor) && maxFactor > 0) {
          maxControl = baseControl * maxFactor;
        }

        if (isContinuousYield) {
          minControl = roundYield(minControl);
          maxControl = roundYield(maxControl);
        } else {
          minControl = Math.max(1, Math.ceil(minControl - 0.0001));
          maxControl = Math.max(minControl, Math.floor(maxControl + 0.0001));
        }

        var v21Note = root.getAttribute('data-v2-scaling-note') || '';
        if (noteEl && v21Note) noteEl.textContent = v21Note;
      }

      if (input) {
        input.setAttribute('min', cleanNumber(minControl));
        input.setAttribute('max', cleanNumber(maxControl));
        input.setAttribute('step', cleanNumber(controlStep));
        if (isContinuousYield) input.setAttribute('inputmode', 'decimal');
      }

      function clampControl(value) {
        value = snapYield(value);
        if (value < minControl) value = minControl;
        if (value > maxControl) value = maxControl;
        return roundYield(value);
      }

      function currentControl() {
        var v = parseFloat(input.value);
        if (isNaN(v)) v = baseControl;
        return clampControl(v);
      }

      function render(targetControl, source) {
        targetControl = clampControl(targetControl);
        var factor = targetControl / baseControl;
        var currentYield = baseYield * factor;
        applyScale(factor);

        input.value = cleanNumber(targetControl);

        if (scalerUnitEl) {
          scalerUnitEl.textContent = displayYieldUnit(targetControl);
        } else if (pluralEl && isServingYield) {
          pluralEl.textContent = nearlyEqual(targetControl, 1) ? '' : 's';
        }

        if (yieldStatValue) {
          if (hasV21Contract && !isServingYield) {
            yieldStatValue.textContent = displayYieldNumber(targetControl) + ' ' + displayYieldUnit(targetControl);
          } else {
            yieldStatValue.textContent = cleanNumber(targetControl);
          }
        }

        var changed = !nearlyEqual(targetControl, baseControl);
        if (resetBtn) resetBtn.hidden = !changed;
        if (noteEl) noteEl.hidden = !changed;
        if (downBtn) downBtn.disabled = targetControl <= minControl + 0.0001;
        if (upBtn) upBtn.disabled = targetControl >= maxControl - 0.0001;

        quickBtns.forEach(function (b) {
          var multiplier = parseFloat(b.getAttribute('data-scale')) || 1;
          var rawTarget = baseControl * multiplier;
          var target = clampControl(rawTarget);
          var exactTarget = isContinuousYield ? roundYield(rawTarget) : Math.round(rawTarget);
          var inRange = exactTarget >= minControl - 0.0001 && exactTarget <= maxControl + 0.0001;

          if (hasV21Contract) b.hidden = !inRange;
          b.setAttribute('aria-pressed', String(inRange && nearlyEqual(target, targetControl)));
        });

        if (source) {
          track('ingredient_scale_used', {
            scale_factor: Math.round(factor * 100) / 100,
            servings_result: targetControl,
            yield_result: currentYield,
            yield_unit: yieldUnit || 'servings',
            method: source,
            first_interaction: !scaleFired,
            v2_contract: hasV21Contract
          });
          scaleFired = true;
        }
      }

      if (downBtn) {
        downBtn.addEventListener('click', function () {
          render(currentControl() - controlStep, 'stepper');
        });
      }
      if (upBtn) {
        upBtn.addEventListener('click', function () {
          render(currentControl() + controlStep, 'stepper');
        });
      }
      if (input) {
        input.addEventListener('change', function () {
          render(currentControl(), 'typed');
        });
        input.addEventListener('blur', function () {
          render(currentControl(), null);
        });
      }
      if (resetBtn) {
        resetBtn.addEventListener('click', function () {
          render(baseControl, 'reset');
        });
      }

      quickBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          var factor = parseFloat(b.getAttribute('data-scale')) || 1;
          render(baseControl * factor, 'preset');
        });
      });

      render(baseControl, null);
    }
  }

  // ---------- Favorites (shared with blog + article hearts) ----------
  function getFavs() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY)) || []; } catch (e) { return []; }
  }
  function setFavs(list) {
    try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) {}
  }

  var favBtn = root.querySelector('[data-recipe-fav]');
  if (favBtn && articleId) {
    var renderFav = function () {
      var isFav = getFavs().indexOf(articleId) !== -1;
      favBtn.classList.toggle('is-fav', isFav);
      favBtn.setAttribute('aria-pressed', String(isFav));
      var label = favBtn.querySelector('[data-fav-label]');
      if (label) label.textContent = isFav ? 'Saved' : 'Save';
    };
    favBtn.addEventListener('click', function () {
      var favs = getFavs();
      var i = favs.indexOf(articleId);
      if (i === -1) { favs.push(articleId); } else { favs.splice(i, 1); }
      setFavs(favs);
      renderFav();
      track('recipe_favorite', { saved: i === -1 });
    });
    renderFav();
  }

  // ---------- Copy link ----------
  var copyBtn = root.querySelector('[data-recipe-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var url = copyBtn.getAttribute('data-url') || window.location.href;
      var done = function () {
        copyBtn.classList.add('is-copied');
        var label = copyBtn.querySelector('[data-copy-label]');
        var orig = label ? label.textContent : '';
        if (label) label.textContent = 'URL copied';
        setTimeout(function () {
          copyBtn.classList.remove('is-copied');
          if (label) label.textContent = orig;
        }, 1600);
        track('recipe_copy_link', {});
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(function () {
          window.prompt('Copy this recipe link:', url);
        });
      } else {
        window.prompt('Copy this recipe link:', url);
      }
    });
  }

  // ---------- Share ----------
  var shareBtn = root.querySelector('[data-recipe-share]');
  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      var url = shareBtn.getAttribute('data-share-url') || window.location.href;
      var title = shareBtn.getAttribute('data-share-title') || document.title;
      track('recipe_share', { method: navigator.share ? 'native' : 'copy_link' });
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url);
      } else {
        window.prompt('Copy this recipe link:', url);
      }
    });
  }

  // ---------- Print / Save as PDF ----------
  // Both use the browser print pipeline, which renders the print stylesheet.
  // The document title becomes the suggested PDF filename, so it is swapped
  // to the bare recipe name for the duration of the dialog.
  function openPrintDialog(eventName) {
    var originalTitle = document.title;
    var cleanTitle = (recipeTitle || originalTitle).split(' | ')[0].trim();
    track(eventName, {});
    document.title = cleanTitle;
    var restore = function () { document.title = originalTitle; };
    if (window.matchMedia) {
      var mql = window.matchMedia('print');
      if (mql.addEventListener) {
        mql.addEventListener('change', function handler(e) {
          if (!e.matches) { restore(); mql.removeEventListener('change', handler); }
        });
      }
    }
    window.addEventListener('afterprint', function handler() {
      restore();
      window.removeEventListener('afterprint', handler);
    });
    window.print();
    setTimeout(restore, 3000);
  }

  var printBtn = root.querySelector('[data-recipe-print]');
  if (printBtn) {
    printBtn.addEventListener('click', function () { openPrintDialog('recipe_print'); });
  }

  var pdfBtn = root.querySelector('[data-recipe-pdf]');
  if (pdfBtn) {
    pdfBtn.addEventListener('click', function () { openPrintDialog('recipe_save_pdf'); });
  }

  // ---------- Shoppable product clicks ----------
  root.addEventListener('click', function (e) {
    var link = e.target.closest('[data-recipe-product-click]');
    if (!link) return;
    track('recipe_product_click', {
      product_title: link.getAttribute('data-product-title') || '',
      product_handle: link.getAttribute('data-product-handle') || '',
      product_price: link.getAttribute('data-product-price') || ''
    });
  });

  // ---------- Product carousel arrows ----------
  root.querySelectorAll('[data-vg-rcarousel]').forEach(function (carousel) {
    var track_ = carousel.querySelector('[data-rcar-track]');
    var prev = carousel.querySelector('[data-rcar-prev]');
    var next = carousel.querySelector('[data-rcar-next]');
    if (!track_ || !prev || !next) return;

    var step = function () { return Math.max(track_.clientWidth * 0.8, 200); };
    var update = function () {
      var max = track_.scrollWidth - track_.clientWidth - 2;
      var scrollable = max > 4;
      prev.hidden = !scrollable || track_.scrollLeft <= 2;
      next.hidden = !scrollable || track_.scrollLeft >= max;
    };
    prev.addEventListener('click', function () { track_.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track_.scrollBy({ left: step(), behavior: 'smooth' }); });
    track_.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  });

  // ---------- Degree symbols ----------
  // The importer writes bare temperatures ("375F (190C)"). Add the degree sign
  // at render time so every existing recipe reads correctly without a re-push.
  function fixDegrees(el) {
    if (!el) return;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var t = node.nodeValue;
      if (!t || t.indexOf('\u00B0') !== -1) return;
      var next = t.replace(/(\d)\s?([FC])\b/g, function (match, digit, letter, offset, whole) {
        // Only treat it as a temperature when a plausible number precedes it.
        var before = whole.slice(Math.max(0, offset - 4), offset + 1);
        if (!/\d{2,3}$/.test(before)) return match;
        return digit + '\u00B0' + letter;
      });
      if (next !== t) node.nodeValue = next;
    });
  }

  fixDegrees(root.querySelector('.recipe-article__steps'));
  fixDegrees(root.querySelector('.recipe-article__tips'));
  fixDegrees(root.querySelector('[data-recipe-body]'));

  // ---------- Previous / next across the whole recipe library ----------
  // Shopify's blog.previous_article / next_article only reach an article or two
  // either side once a blog holds thousands of posts, so the arrows walk the
  // Typesense index instead. Falls back to whatever Liquid rendered when no
  // Typesense credentials are set.
  var tsNav = root.querySelector('[data-recipe-ts-nav]');
  if (tsNav) {
    var tsHost = tsNav.getAttribute('data-ts-host');
    var tsCollection = tsNav.getAttribute('data-ts-collection');
    var tsKey = tsNav.getAttribute('data-ts-key');

    if (tsHost && tsCollection && tsKey) {
      var tsProtocol = tsNav.getAttribute('data-ts-protocol') || 'https';
      var tsPort = tsNav.getAttribute('data-ts-port') || '';
      var tsPath = tsNav.getAttribute('data-ts-path') || '';
      var sortField = tsNav.getAttribute('data-ts-sort') || 'published_at';
      var currentUrl = tsNav.getAttribute('data-current-url') || window.location.pathname;
      var anchorValue = parseInt(tsNav.getAttribute('data-published-ts'), 10);

      if (tsPath === '/' ) tsPath = '';
      if (tsPath && tsPath.charAt(0) !== '/') tsPath = '/' + tsPath;
      if (tsPath.slice(-1) === '/') tsPath = tsPath.slice(0, -1);

      var endpoint = tsProtocol + '://' + tsHost + (tsPort ? ':' + tsPort : '') + tsPath +
                     '/collections/' + encodeURIComponent(tsCollection) + '/documents/search';

      var sameUrl = function (a, b) {
        if (!a || !b) return false;
        return a.replace(/^https?:\/\/[^/]+/, '').split('?')[0] ===
               b.replace(/^https?:\/\/[^/]+/, '').split('?')[0];
      };

      // Pull a small window so ties on the sort value (bulk-published recipes
      // can share a timestamp) still yield a genuine neighbour.
      var neighbour = function (direction) {
        var op = direction === 'older' ? ':<=' : ':>=';
        var order = direction === 'older' ? ':desc' : ':asc';
        var params = new URLSearchParams({
          q: '*',
          query_by: 'title',
          filter_by: sortField + op + anchorValue,
          sort_by: sortField + order,
          per_page: '8',
          page: '1'
        });
        return fetch(endpoint + '?' + params.toString(), {
          headers: { 'X-TYPESENSE-API-KEY': tsKey }
        }).then(function (r) {
          if (!r.ok) throw new Error('typesense ' + r.status);
          return r.json();
        }).then(function (payload) {
          var hits = (payload && payload.hits) || [];
          for (var i = 0; i < hits.length; i++) {
            var doc = hits[i].document || {};
            if (doc.url && !sameUrl(doc.url, currentUrl)) return doc;
          }
          return null;
        });
      };

      var applyLink = function (selector, doc) {
        root.querySelectorAll(selector).forEach(function (el) {
          if (!doc) {
            if (el.classList.contains('recipe-sidenav__btn')) el.hidden = true;
            return;
          }
          el.hidden = false;
          el.setAttribute('href', doc.url);
          var title = String(doc.title || 'Recipe').split(' | ')[0];
          var label = el.querySelector('.recipe-sidenav__label, .recipe-article__pager-title');
          if (label) label.textContent = title;
          if (el.classList.contains('recipe-sidenav__btn')) {
            var dir = el.classList.contains('recipe-sidenav__btn--prev') ? 'Previous' : 'Next';
            el.setAttribute('aria-label', dir + ' recipe: ' + title);
          }
        });
      };

      if (!isNaN(anchorValue)) {
        neighbour('newer').then(function (doc) {
          applyLink('.recipe-sidenav__btn--prev, .recipe-article__pager-link--prev', doc);
        }).catch(function (e) { console.warn('recipe nav (prev):', e); });

        neighbour('older').then(function (doc) {
          applyLink('.recipe-sidenav__btn--next, .recipe-article__pager-link--next', doc);
        }).catch(function (e) { console.warn('recipe nav (next):', e); });
      }
    }
  }

  // ---------- Keyboard browsing: left / right arrow keys ----------
  // Ignored while typing, so the comment form and the servings input are safe.
  document.addEventListener('keydown', function (e) {
    if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) return;
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;

    var el = document.activeElement;
    if (el) {
      var tag = (el.tagName || '').toLowerCase();
      if (tag === 'input' || tag === 'textarea' || tag === 'select' || el.isContentEditable) return;
    }

    var selector = e.key === 'ArrowLeft'
      ? '.recipe-sidenav__btn--prev, .recipe-article__pager-link--prev'
      : '.recipe-sidenav__btn--next, .recipe-article__pager-link--next';
    var link = root.querySelector(selector);
    if (!link || link.hidden) return;
    var href = link.getAttribute('href');
    if (!href || href === '#') return;

    e.preventDefault();
    track('recipe_keyboard_nav', { direction: e.key === 'ArrowLeft' ? 'prev' : 'next' });
    window.location.href = href;
  });

  // ---------- Convert imported bullet-character paragraphs into real lists ----------
  var body = root.querySelector('[data-recipe-body]');
  if (body) {
    var BULLET = '\u25CF';
    var clean = function (s) {
      return s.replace(/^(?:\s|&nbsp;|<br\s*\/?\s*>)+/gi, '').replace(/(?:\s|&nbsp;|<br\s*\/?\s*>)+$/gi, '');
    };
    body.querySelectorAll('p').forEach(function (p) {
      if (p.innerHTML.indexOf(BULLET) === -1) return;
      var parts = p.innerHTML.split(BULLET);
      var intro = clean(parts.shift());
      var items = parts.map(clean).filter(function (x) { return x !== ''; });
      if (!items.length) return;
      var ul = document.createElement('ul');
      ul.className = 'vg-bullets';
      items.forEach(function (it) {
        var li = document.createElement('li');
        li.innerHTML = it;
        ul.appendChild(li);
      });
      if (intro) {
        p.innerHTML = intro;
        p.insertAdjacentElement('afterend', ul);
      } else {
        p.replaceWith(ul);
      }
    });
  }
})();